<script setup lang="ts">
/**
 * The standard card surface — one place that owns radius, border, padding and
 * shadow so the ~dozen cards across Today and the subject page cannot drift.
 *
 * `flush` drops the padding for cards whose content manages its own insets
 * (hairline-separated row lists, which need rows to span the full width).
 */
withDefaults(defineProps<{ flush?: boolean }>(), { flush: false });
</script>

<template>
  <section class="card" :class="{ 'card-flush': flush }">
    <slot />
  </section>
</template>

<style scoped>
.card {
  padding: var(--sp-5);
  background: var(--rl-bg);
  border: 1px solid var(--rl-border-subtle);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xs);
}

.card-flush {
  padding: 0;
  overflow: hidden;
}
</style>
